import React, { Component } from 'react';
import '../style/counters.css';

function formatDate(tm) {
    const d = new Date(tm);
    return d.toLocaleDateString(navigator.language);
}

function formatBytes(b) {
    if (b > 1000000000) return `${Math.round(b/100000000)/10}GB`;
    if (b > 1000000) return `${Math.round(b/100000)/10}MB`;
    if (b > 1900) return `${Math.round(b/100)/10}KB`;
    return `${b} bytes`;
}

function formatPercent(frac) {
  if ('number' !== typeof frac) {
    return '-';
  }
  return `${Math.round(frac*1000)/10}%`;
}

function formatNumber(num) {
    if (num.toLocaleString) {
        return num.toLocaleString(navigator.language);
    }
    return num;
}

export default class Counters extends Component {

  render() {
    if (!this.props.counters) {
        return <p class="error">Unable to get data. Please reload the page to try again.</p>;
    }
    const recent = this.props.counters.recent;
    const monthly = this.props.counters.monthly;
    const columns = [];
    if (recent) {
        if (recent.today && recent.today.request) {
            columns.push({header: 'Today', data: recent.today});
        }
        if (recent.yesterday && recent.yesterday.request) {
            columns.push({header: 'Yesterday', data: recent.yesterday});
        }
        if (recent.billingPeriod && recent.billingPeriod.request) {
            columns.push({header: `Since ${formatDate(recent.billingPeriodStart)}`, data: recent.billingPeriod});
        }
    }

    return <div className="counters">
        <h3><abbr>API</abbr> Usage</h3>
        {recent ? <Usage columns={columns} /> : 'Waiting for data…'}
        {monthly ? <Monthly monthly={monthly} /> : ''}
    </div>;
  }
}


function Monthly(props) {
    return <table className="monthly"><caption>Monthly usage</caption>
    <thead><tr>
        <th>Month</th>
        <th>Optimizations</th>
        <th>Total requests</th>
        <th>Cached</th>
        <th>In</th><th>Out</th>
    </tr></thead>
    <tbody>
        {props.monthly.map(m => {
            return <tr key={m.month}>
                <td>{m.month.substr(0,4)}-{m.month.substr(4)}</td>
                <td>{formatNumber(m.billed)}</td>
                <td>{formatNumber(m.request)}</td>
                <td>{formatNumber(m.cache)}</td>
                <td>{formatBytes(m.input_bytes)}</td>
                <td>{formatBytes(m.output_bytes)}</td>
            </tr>;
        })}
    </tbody></table>;
}

function Usage(props) {
    const columns = props.columns;
    if (!columns.length) {
        return <p>You haven’t optimized any images yet. <a href="/api/start">Use the API</a></p>;
    }
    return <table className="usage"><tbody>
      <tr><th></th>{
        columns.map((c,i) => <th key={i}>{c.header}</th>)
      }</tr>
      <tr><th>Optimizations</th>{columns.map((c,i) => <td key={i}>{formatNumber(c.data.billed)}</td>)}<td className="notes">Successful requests for billing purposes.</td></tr>
      <tr><th>Data processed</th>{columns.map((c,i) => <td key={i}>{formatBytes(c.data.input_bytes)}</td>)}<td className="notes" rowSpan="2">Only counts data sent to the API. Excludes CDN (cached images viewed by website visitors).</td></tr>
      <tr><th>Data output</th>{columns.map((c,i) => <td key={i}>{formatBytes(c.data.output_bytes)}<br/>({formatPercent(1-(c.data.output_bytes/c.data.input_bytes))} reduction)</td>)}</tr>
      <tr><th>Total requests</th>{columns.map((c,i) => <td key={i}>{formatNumber(c.data.request)}</td>)}<td className="notes">All request to the API, including duplicates, unoptimized, errors, etc.</td></tr>
      <tr><th>Cached</th>{columns.map((c,i) => <td key={i}>{formatNumber(c.data.cache)}{c.data.cache ? ` (${formatPercent(c.data.cache/c.data.request)})` : ''}</td>)}<td className="notes">API requests for images we&rsquo;ve alredy processed.</td></tr>
      <tr><th>Rejected</th>{columns.map((c,i) => <td key={i}>{formatNumber(c.data.user_error)}</td>)}<td className="notes">Invalid options, broken links, access denied.</td></tr>
      <tr><th>Errors</th>{columns.map((c,i) => <td key={i}>{formatNumber(c.data.api_error)}</td>)}<td className="notes">Errors during optimization.</td></tr>
    </tbody></table>;
}



// WEBPACK FOOTER //
// ./src/ui/Counters.jsx